import Vue from "vue";
import Router from "vue-router";
// import store from "@/plugins/store/index";

Vue.use(Router);

let router = new Router({
    mode: "history", //UNCOMMET THIS LINE IF YOU WANT TO DISABLE # IN PATH
    routes: [
        {
            path: "/wait-for-approval",
            name: "WAIT_FOR_APPROVAL",
            component: () => import("@/components/Pages/WaitForApproval"),
            meta: {guest: true},
        },
        {
            path: "/page_not_found",
            name: "PAGE_NOT_FOUND",
            component: () => import("@/components/app/NotFound.vue"),
            meta: {guest: true},
        },
        {
            //TODO: ADD THE ROUTES HERE
            path: "/",
            component: () => import("@/components/app/Index.vue"),
            children: [
                {
                    path: "/:key",
                    name: "KYC_DOCUMENTS",
                    component: () => import("@/components/Pages/Documents"),
                    meta: {guest: true},
                },
            ],
        },
        {
            path: '*',
            component: () => import("@/components/app/NotFound.vue"),
        },
    ],
});

// router.beforeEach(function (to, from, next) {
//     //If the resource is public.
//     // const isAuth = store.state.security.jwt != null;
//     // const carrier_status = store.state.carrier.item || {status: 'ANYTHING_OTHER_STATUS'}
//     // console.log('isAuth', isAuth);
//     //
//     // if (to.meta.guest) {
//     //     if (!isAuth) return next();
//     //     if (
//     //         isAuth &&
//     //         to.name !== 'Login'
//     //         && to.name !== 'Register'
//     //         && to.name !== 'forgot-password'
//     //         && to.name !== 'change_forgot_password'
//     //     ) return next();
//     //     return next({name: 'bills'})
//     //
//     // } else {
//     //     if (to.name == 'bills' && carrier_status.status != 'CONTRACTS_SIGNED') {
//     //         return next({name: 'carrier'})
//     //     }
//     //     let borrarBreadcrumbYAvanzar = function () {
//     //         store.dispatch("app/borrarBreadcrumb", null);
//     //         next();
//     //     };
//     //     store.dispatch("security/verifyJwt", borrarBreadcrumbYAvanzar);
//     // }
// });

export default router;
